import t from "@swup/plugin";
import { Location as r, classify as e, matchPath as n } from "swup";
function s() {
  return s = Object.assign ? Object.assign.bind() : function(t2) {
    for (var r2 = 1; r2 < arguments.length; r2++) {
      var e2 = arguments[r2];
      for (var n2 in e2)
        ({}).hasOwnProperty.call(e2, n2) && (t2[n2] = e2[n2]);
    }
    return t2;
  }, s.apply(null, arguments);
}
window.process || (window.process = {}), window.process.env || (window.process.env = {});
const o = ["test"].includes(String(process.env.NODE_ENV)), i = ["development", "test"].includes(String(process.env.NODE_ENV)), l = (t2, r2, e2) => null == t2 ? t2 : `\x1B[${r2}m${String(t2)}\x1B[${e2}m`, a = (t2) => o ? t2 : `\u{1F9E9} ${((t3) => l(t3, 1, 22))(t2)}`, u = (t2) => o ? t2 : ((t3) => l(t3, 94, 39))(t2);
class c {
  log(...t2) {
    const r2 = t2.shift();
    console.log(a(r2), ...t2);
  }
  warn(...t2) {
    const r2 = t2.shift();
    console.warn(a(r2), ...t2);
  }
  error(...t2) {
    const r2 = t2.shift();
    console.error(a(r2), ...t2);
  }
  logIf(t2, ...r2) {
    t2 && this.log(...r2);
  }
  warnIf(t2, ...r2) {
    t2 && this.warn(...r2);
  }
  errorIf(t2, ...r2) {
    t2 && this.error(...r2);
  }
}
const g = (t2) => {
  !function({ parsedRules: t3, swup: e2, logger: n2 }) {
    const s2 = e2.getCurrentUrl();
    t3.filter((t4) => t4.matchesFrom(s2) || t4.matchesTo(s2)).forEach((t4) => {
      t4.containers.forEach((t5) => {
        const o2 = y(`${t5}:not([data-swup-fragment])`, e2);
        if (!o2)
          return;
        const l2 = o2.getAttribute("data-swup-fragment-url");
        l2 && i && (null == n2 || n2.log(`fragment url ${u(l2)} for ${u(t5)} provided by server`));
        const { url: a2 } = r.fromUrl(l2 || s2);
        o2.setAttribute("data-swup-fragment", ""), o2.__swupFragment = { url: a2, selector: t5 };
      });
    });
  }(t2), function({ logger: t3, swup: r2 }) {
    const e2 = "data-swup-link-to-fragment";
    document.querySelectorAll(`a[${e2}]`).forEach((n2) => {
      var s2;
      const o2 = n2.getAttribute(e2);
      if (!o2)
        return void (i && (null == t3 || t3.warn(`[${e2}] needs to contain a valid fragment selector`)));
      const l2 = y(o2, r2);
      if (!l2)
        return void (i && (null == t3 || t3.log(`ignoring ${u(`[${e2}="${o2}"]`)} as ${u(o2)} is missing`)));
      const a2 = null == (s2 = l2.__swupFragment) ? void 0 : s2.url;
      a2 ? (m(a2, r2.getCurrentUrl()) && i && (null == t3 || t3.warn(`The fragment URL of ${o2} is identical to the current URL. This could mean that [data-swup-fragment-url] needs to be provided by the server.`)), n2.href = a2) : i && (null == t3 || t3.warn(`no fragment infos found on ${o2}`));
    });
  }(t2), function({ logger: t3 }) {
    document.querySelectorAll("dialog[data-swup-fragment]").forEach((r2) => {
      r2.__swupFragment ? r2.__swupFragment.modalShown || (r2.__swupFragment.modalShown = true, r2.removeAttribute("open"), null == r2.showModal || r2.showModal(), r2.addEventListener("keydown", (t4) => "Escape" === t4.key && t4.preventDefault())) : i && (null == t3 || t3.warn("fragment properties missing on element:", r2));
    });
  }(t2);
}, f = (t2, r2) => {
  var e2;
  const n2 = null == (e2 = t2.__swupFragment) ? void 0 : e2.url;
  return !!n2 && m(n2, r2);
}, m = (t2, r2) => h(t2) === h(r2), h = (t2) => {
  if (!t2.trim())
    return t2;
  const e2 = r.fromUrl(t2);
  return e2.searchParams.sort(), e2.pathname.replace(/\/+$/g, "") + e2.search;
}, p = (t2) => {
  const r2 = t2.from.url, e2 = t2.to.url;
  if (r2 && e2)
    return { from: r2, to: e2 };
}, d = (t2, r2) => {
  if (null == t2 || !t2.name)
    return;
  const { name: e2, containers: n2 } = t2;
  n2.forEach((t3) => {
    var n3;
    null == (n3 = document.querySelector(t3)) || n3.classList.toggle(`to-${e2}`, r2);
  });
}, w = (t2, r2, e2) => r2.find((r3) => r3.matches(t2, e2));
function v(t2) {
  return !!t2 && t2.containers.every((t3) => {
    var r2;
    return "template" === (null == (r2 = document.querySelector(t3)) || null == (r2 = r2.tagName) ? void 0 : r2.toLowerCase());
  });
}
function y(t2, r2) {
  for (const e2 of r2.options.containers) {
    const r3 = document.querySelector(e2);
    if (null != r3 && r3.matches(t2))
      return r3;
    const n2 = null == r3 ? void 0 : r3.querySelector(t2);
    if (n2)
      return n2;
  }
}
function S(t2) {
  if (!Array.isArray(t2))
    throw new Error("cloneRules() expects an array of rules");
  return t2.map((t3) => s({}, t3, { from: Array.isArray(t3.from) ? [...t3.from] : t3.from, to: Array.isArray(t3.to) ? [...t3.to] : t3.to, containers: [...t3.containers] }));
}
class $ {
  constructor(t2) {
    var r2, s2;
    this.matchesFrom = void 0, this.matchesTo = void 0, this.swup = void 0, this.from = void 0, this.to = void 0, this.containers = void 0, this.name = void 0, this.scroll = false, this.focus = void 0, this.logger = void 0, this.if = () => true, this.swup = t2.swup, this.logger = t2.logger, this.from = t2.from || "", this.to = t2.to || "", t2.name && (this.name = e(t2.name)), void 0 !== t2.scroll && (this.scroll = t2.scroll), void 0 !== t2.focus && (this.focus = t2.focus), "function" == typeof t2.if && (this.if = t2.if), this.containers = this.parseContainers(t2.containers), i && (null == (r2 = this.logger) || r2.errorIf(!this.to, "Every fragment rule must contain a 'to' path", this), null == (s2 = this.logger) || s2.errorIf(!this.from, "Every fragment rule must contain a 'from' path", this)), this.matchesFrom = n(this.from), this.matchesTo = n(this.to);
  }
  parseContainers(t2) {
    var r2, e2;
    return Array.isArray(t2) && t2.length ? (e2 = t2.map((t3) => t3.trim()), [...new Set(e2)]).filter((t3) => {
      var r3;
      const e3 = this.validateSelector(t3);
      return null == (r3 = this.logger) || r3.errorIf(e3 instanceof Error, e3), true === e3;
    }) : (i && (null == (r2 = this.logger) || r2.error("Every fragment rule must contain an array of containers", this.getDebugInfo())), []);
  }
  validateSelector(t2) {
    return t2.startsWith("#") ? !t2.match(/\s|>/) || new Error(`fragment selectors must not be nested: ${t2}`) : new Error(`fragment selectors must be IDs: ${t2}`);
  }
  getDebugInfo() {
    const { from: t2, to: r2, containers: e2 } = this;
    return { from: String(t2), to: String(r2), containers: String(e2) };
  }
  matches(t2, e2) {
    var n2;
    if (!this.if(e2))
      return i && (null == (n2 = this.logger) || n2.log("ignoring fragment rule due to custom rule.if:", this)), false;
    const { url: s2 } = r.fromUrl(t2.from), { url: o2 } = r.fromUrl(t2.to);
    if (!this.matchesFrom(s2) || !this.matchesTo(o2))
      return false;
    for (const t3 of this.containers) {
      const r2 = this.validateFragmentSelectorForMatch(t3);
      var l2;
      if (r2 instanceof Error)
        return i && (null == (l2 = this.logger) || l2.error(r2, this.getDebugInfo())), false;
    }
    return true;
  }
  validateFragmentSelectorForMatch(t2) {
    return document.querySelector(t2) ? !!y(t2, this.swup) || new Error(`skipping rule since ${u(t2)} is outside of swup's default containers`) : new Error(`skipping rule since ${u(t2)} doesn't exist in the current document`);
  }
}
const _ = function(t2) {
  const r2 = p(t2);
  r2 && w(r2, this.parsedRules, t2) && (t2.scroll.reset = false);
}, R = async function(t2) {
  const r2 = p(t2);
  if (!r2)
    return;
  const e2 = this.getFragmentVisit(r2, t2);
  if (!e2)
    return;
  var n2;
  t2.fragmentVisit = e2, i && (null == (n2 = this.logger) || n2.log(`fragment visit: ${u(t2.fragmentVisit.containers.join(", "))}`)), t2.scroll = function(t3, r3) {
    return "boolean" == typeof t3.scroll ? s({}, r3, { reset: t3.scroll }) : "string" != typeof t3.scroll || r3.target ? r3 : s({}, r3, { target: t3.scroll });
  }(e2, t2.scroll);
  const o2 = t2.a11y;
  var l2;
  void 0 !== e2.focus && (i && (null == (l2 = this.logger) || l2.errorIf(!o2, "Can't set visit.a11y.focus. Is @swup/a11y-plugin installed?")), o2 && (o2.focus = e2.focus)), t2.animation.scope = t2.fragmentVisit.containers, t2.containers = t2.fragmentVisit.containers, t2.animation.selector = t2.fragmentVisit.containers.join(","), d(e2, true);
}, b = function(t2, r2) {
  var e2, n2;
  t2.fragmentVisit && v(t2.fragmentVisit) && (i && (null == (e2 = this.logger) || e2.log(`${u("out")}-animation skipped for ${u(null == (n2 = t2.fragmentVisit) ? void 0 : n2.containers.toString())}`)), r2.skip = true);
}, E = function(t2, r2) {
  var e2, n2;
  t2.fragmentVisit && v(t2.fragmentVisit) && (i && (null == (e2 = this.logger) || e2.log(`${u("in")}-animation skipped for ${u(null == (n2 = t2.fragmentVisit) ? void 0 : n2.containers.toString())}`)), r2.skip = true);
}, F = function(t2, r2) {
  var e2;
  if (t2.trigger.el || !t2.to.url)
    return;
  const n2 = this.swup.cache.get(t2.to.url);
  n2 && n2.fragmentHtml && (t2.to.document = new DOMParser().parseFromString(n2.fragmentHtml, "text/html"), t2.to.html = n2.fragmentHtml, i && (null == (e2 = this.logger) || e2.log(`fragment cache used for ${u(t2.to.url)}`)));
}, A = function(t2) {
  d(t2.fragmentVisit, true), g(this), (({ swup: t3, logger: r2 }) => {
    const e2 = t3.getCurrentUrl(), n2 = t3.cache, s2 = n2.get(e2);
    if (!s2)
      return;
    const o2 = new DOMParser().parseFromString(s2.html, "text/html"), l2 = [], a2 = Array.from(document.querySelectorAll("[data-swup-fragment]")).filter((t4) => !t4.matches("template") && !f(t4, e2));
    a2.length && (t3.options.cache ? (a2.forEach((t4) => {
      var e3, s3;
      if (null != t4.querySelector("[data-swup-fragment]"))
        return;
      const a3 = null == (e3 = t4.__swupFragment) ? void 0 : e3.url;
      if (!a3)
        return void (i && (null == r2 || r2.warn("no fragment url found:", t4)));
      const u2 = null == (s3 = t4.__swupFragment) ? void 0 : s3.selector;
      if (!u2)
        return void (i && (null == r2 || r2.warn("no fragment selector found:", t4)));
      const c2 = n2.get(a3);
      if (!c2)
        return;
      const g2 = o2.querySelector(u2);
      if (!g2)
        return;
      const f2 = new DOMParser().parseFromString(c2.html, "text/html").querySelector(u2);
      f2 && (f2.setAttribute("data-swup-fragment-url", a3), g2.replaceWith(f2), l2.push(t4));
    }), l2.length && (n2.update(e2, { fragmentHtml: o2.documentElement.outerHTML }), l2.forEach((t4) => {
      var e3, n3;
      const s3 = (null == (e3 = t4.__swupFragment) ? void 0 : e3.url) || "", o3 = (null == (n3 = t4.__swupFragment) ? void 0 : n3.selector) || "";
      i && (null == r2 || r2.log(`updated cache with ${u(o3)} from ${u(s3)}`));
    }))) : i && (null == r2 || r2.warn("can't cache foreign fragment elements without swup's cache")));
  })(this);
}, V = function(t2) {
  d(t2.fragmentVisit, false);
};
class q extends t {
  get parsedRules() {
    return this._parsedRules;
  }
  constructor(t2) {
    super(), this.name = "SwupFragmentPlugin", this.requires = { swup: ">=4.6" }, this._rawRules = [], this._parsedRules = [], this.options = void 0, this.defaults = { rules: [], debug: false }, this.logger = void 0, this.options = s({}, this.defaults, t2);
  }
  mount() {
    const t2 = this.swup;
    var r2;
    this.setRules(this.options.rules), i && this.options.debug && (this.logger = new c()), this.before("link:self", _), this.on("visit:start", R), this.before("animation:out:await", b), this.before("animation:in:await", E), this.before("content:replace", F), this.on("content:replace", A), this.on("visit:end", V), i && (null == (r2 = this.logger) || r2.warnIf(!t2.options.cache, "fragment caching will only work with swup's cache being active")), g(this);
  }
  unmount() {
    super.unmount(), document.querySelectorAll("[data-swup-fragment]").forEach((t2) => {
      t2.removeAttribute("data-swup-fragment-url"), delete t2.__swupFragment;
    });
  }
  setRules(t2) {
    var r2;
    this._rawRules = S(t2), this._parsedRules = t2.map((t3) => this.parseRule(t3)), i && (null == (r2 = this.logger) || r2.log("Updated fragment rules", this.getRules()));
  }
  getRules() {
    return S(this._rawRules);
  }
  prependRule(t2) {
    this.setRules([t2, ...this.getRules()]);
  }
  appendRule(t2) {
    this.setRules([...this.getRules(), t2]);
  }
  parseRule(t2) {
    return new $(s({}, t2, { logger: this.logger, swup: this.swup }));
  }
  getFragmentVisit(t2, r2) {
    const e2 = w(t2, this.parsedRules, r2 || this.swup.createVisit(t2));
    if (!e2)
      return;
    const n2 = ((t3, r3, e3, n3) => {
      let s3 = r3.map((t4) => {
        const r4 = document.querySelector(t4);
        return r4 ? y(t4, e3) ? { selector: t4, el: r4 } : (i && (null == n3 || n3.error(`${u(t4)} is outside of swup's default containers`)), false) : (i && (null == n3 || n3.log(`${u(t4)} missing in current document`)), false);
      }).filter((t4) => !!t4);
      const o3 = s3.every((r4) => f(r4.el, t3.to));
      return m(t3.from, t3.to) || o3 && "navigate" === e3.options.linkToSelf || (s3 = s3.filter((r4) => !f(r4.el, t3.to) || (i && (null == n3 || n3.log(`ignoring fragment ${u(r4.selector)} as it already matches the current URL`)), false))), s3.map((t4) => t4.selector);
    })(t2, e2.containers, this.swup, this.logger);
    if (!n2.length)
      return;
    const { name: s2, scroll: o2, focus: l2 } = e2;
    return { containers: n2, name: s2, scroll: o2, focus: l2 };
  }
}
export { q as default };
